import ActionPanel from '@/components/ActionPanel';
import PageContent from '@/components/PageContent';
import { AchievementTypeEnum, UpsertAchievement, UpsertRunEventAchievementType } from '@/models/achievement.model';
import { BaseErrorModel, BaseResponseModel } from '@/models/core.model';
import { RunEventDistance } from '@/models/run-event-distance.model';
import { upsertAchievement } from '@/services/achievement.service';
import { getRunEvent } from '@/services/run-event.service';
import { jsDateToZone } from '@/utils/date-time';
import { toastErrorMessage, toastSuccessMessage } from '@/utils/toasterMessage';
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Message, PanelGroup, useToaster } from 'rsuite';



interface RunEventDistanceActionsProps{
    formObject?: RunEventDistance;
    fetchData: () => void;
};

const RunEventDistanceActions: React.FC<RunEventDistanceActionsProps> = ({formObject, fetchData}) => {
  const [loadingCreateAchievement, setLoadingCreateAchievement] = useState(false);

  const nav = useNavigate();
  const toaster = useToaster();

  const handleClickCreateAchievement = () => {
    if(!formObject) return;

    const handleYesClick = async () => {
      setLoadingCreateAchievement(true);
      try {
        const runEvent = (await getRunEvent(formObject.runEventId)).result;

        const model : UpsertAchievement & UpsertRunEventAchievementType = {
          name: `${runEvent?.name ?? formObject.id} - Start: ${jsDateToZone(formObject.startDate, runEvent.city.ianaTimeZoneId)}`,
          type: AchievementTypeEnum.Event,
          supportingCityId: runEvent.cityId,
          supportingCountryId: runEvent.city?.country?.id,
          runEventDistanceId: formObject.id,
        };
        const result: BaseResponseModel<null> = await upsertAchievement(model);
        if (result.success) {
          toastSuccessMessage(`Achievement Successfully Created.`);
          fetchData();
        }
      } catch (err) {
        const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
        toastErrorMessage(`Error in creating Achievement:${errorModel?.errorMessage}`);
      }
      finally {
        setLoadingCreateAchievement(false);
        toaster.clear(); 
      }
    };

    const handleNoClick = () => {
      toaster.clear(); 
    };

    toaster.push(
      <Message type="info" closable>
        <p style={{marginBottom:10}}>Are you sure you want to <strong>Create Achievement</strong>?</p>
        <div>
          <Button appearance="primary" onClick={handleYesClick}>Yes</Button>
          <Button appearance="subtle" onClick={handleNoClick} style={{ marginLeft:10}}>No</Button>
        </div>
      </Message>,
      { placement: 'topCenter', duration: 0 }
    );

  };


    return (
        <PageContent>
            <PanelGroup>
                <ActionPanel
                  title='Create Achievement'
                  description='This action let create a new achievement for current run event distance, if not already created.'
                  onClick={handleClickCreateAchievement}
                  loading={loadingCreateAchievement}
                  disabled={formObject?.hasAchievement}
                />
            </PanelGroup>
        </PageContent>
    );
};

export default RunEventDistanceActions;
